import React, { useState, useEffect, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { Divider } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import { MIContext } from "./MIContext";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
  },
  indicator: {
    backgroundColor: "white",
  },

  selected: {
    backgroundColor: "green !important",
  },
  formWrapper: {
    background: "#fff",
    width: "400px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "capitalize",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "center",
    "& button": {
      marginRight: "20px",
    },
  },
  tabStyle: {
    borderRadius: "7px",
    marginRight: "20px",
    height: "16px",
    textTransform: "initial",
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function ManageTemplate(props) {
  const rawData=[];
  const theme = useTheme();
  const classes = useStyles();
  const [data] = useState(rawData)
  const {action,modules,setModules,setAction,setCurrentSelection} = useContext(MIContext)
  const [feildValue, setFeildValue] = useState([]);
  const isOpen = action === "view_summary" 


  const handleClose = (data, id) => {
    let moduleList = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(modules);
      setModules(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter((base) => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setCurrentSelection({});
  };
  const [value, setValue] = React.useState(2);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setFeildValue(data.module_form_fields);
  }, [feildValue]);


  return (
    <div>
      <Dialog
        fullWidth
        maxWidth={"xl"}
        disableBackdropClick
        disableEscapeKeyDown
        style={{ height: "70%" }}
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          <Grid
            container
            spacing={1}
            alignItems={"center"}
            justifyContent={"flex-start"}
          >
            <Grid item xs={3}>
              Assignment summary (Karen Fuge - 0320 - EC)
            </Grid>
            <Grid item xs={6}>
              Organization: SKY Corporation
            </Grid>
            <Grid item xs={3}>
              View assignment details
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <div style={{ marginTop: "5%" }} className={classes.root}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              classes={{
                indicator: classes.indicator,
                selected: classes.selected,
              }}
              aria-label="full width tabs example"
            >
              <Tab
                variant="contained"
                className={classes.tabStyle}
                label="Session details"
                {...a11yProps(0)}
              />
              <Tab
                className={classes.tabStyle}
                label="Coaching agreement form"
                {...a11yProps(1)}
              />
              <Tab
                className={classes.tabStyle}
                label="Leadership competency"
                {...a11yProps(2)}
              />
              <Tab
                className={classes.tabStyle}
                label="Evaluation form"
                {...a11yProps(3)}
              />
              <Tab
                className={classes.tabStyle}
                label="Costs"
                {...a11yProps(4)}
              />
              <Tab className={classes.tabStyle} label="SLA" {...a11yProps(5)} />
            </Tabs>
            {/* </AppBar> */}

            <TabPanel value={value} index={0} dir={theme.direction}>
              Item Two
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
              Item Two
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction}>
              Item Two
            </TabPanel>
            <TabPanel value={value} index={3} dir={theme.direction}>
              Item four
            </TabPanel>
          </div>
        </DialogContent>
      </Dialog>
      )
    </div>
  );
}

export default ManageTemplate;
